import { prop } from 'ramda'

export const available = prop('available')
export const size = prop('size')
